import React from 'react';

const Search = (): JSX.Element => {
  return <div>Search page !</div>;
};

export default Search;
